var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-wrapper"},[_c('iframe',{ref:"bullFrame",staticStyle:{"margin":"0"},attrs:{"src":_vm.bullUrl,"width":"100%","height":_vm.setHeight(),"id":"bullFrame","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }